import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialGroupContractState: Dtos.GroupContract & IRegistrationFormState = {
    id: null,
    groupId: null,
    group: null,
    agreementName: null,
    noOfOriginalCTRARequired: null,
    groupContractSiteTypeId: null,
    groupContractSiteType: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    groupConfidentialityDeed: null
}

export interface IGroupContractReduxFormState {
    id: IFieldState<number>,
    groupId: IFieldState<number>,
    group: IFieldState<Dtos.Group>,
    agreementName: IFieldState<string>,
    noOfOriginalCTRARequired: IFieldState<number>,
    groupContractSiteTypeId: IFieldState<number>,
    groupContractSiteType: IFieldState<Dtos.GroupContractSiteType>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    groupConfidentialityDeed: IFieldState<Dtos.GroupConfidentialityDeed>
}
